export default __webpack_public_path__ + "static/media/hero-bg.2f7a29da.jpg";